const tabSelector = '[data-tab-key="mine"]';
const badgeSelector = '#my-assignments-notification-count';

const assignmentText = (count) => count === 1 ? 'assignment' : 'assignments';
const newOrUpdatedAssignmentsText = (count) => `${count} new or updated ${assignmentText(count)}`;

const notificationElements = () => {
    const tab = document.querySelector(tabSelector);
    const badge = document.querySelector(badgeSelector);
    const tabContainer = tab ? tab.closest('.assignment_resource__main_panel__top_bar__tabs-tab') : null;

    return { tab, badge, tabContainer };
};

const disposeTooltip = (element) => {
    if (!element || !window.$) return;

    $(element).tooltip('hide').tooltip('dispose');
};

const refreshTooltip = (element) => {
    if (!element || !window.$) return;

    disposeTooltip(element);
    $(element).tooltip({ trigger: 'hover', container: 'body' });
};

const bindTooltipClickDismissal = (element) => {
    if (!element || element.dataset.assignmentResourceTooltipDismissalBound) return;

    element.dataset.assignmentResourceTooltipDismissalBound = 'true';
    element.addEventListener('click', function () {
        disposeTooltip(element);
    });
};

const clearTooltipText = (element) => {
    if (!element) return;

    element.removeAttribute('title');
    element.removeAttribute('data-bs-original-title');
};

const setTooltipText = (element, text) => {
    if (!element) return;

    element.setAttribute('title', text);
    element.setAttribute('data-bs-original-title', text);
};

const clearNotificationText = (element) => {
    if (!element) return;

    clearTooltipText(element);
    element.removeAttribute('aria-label');
};

const setNotificationText = (element, text, ariaLabel = text) => {
    if (!element) return;

    setTooltipText(element, text);
    element.setAttribute('aria-label', ariaLabel);
};

const hideTabCount = ({ tab, badge, tabContainer }) => {
    disposeTooltip(tabContainer);
    badge.textContent = '';
    badge.hidden = true;
    clearNotificationText(tab);
    clearNotificationText(tabContainer);
};

const showTabCount = ({ tab, badge, tabContainer }, notificationCount) => {
    const text = newOrUpdatedAssignmentsText(notificationCount);

    badge.textContent = notificationCount;
    badge.hidden = false;
    setNotificationText(tab, text, `My Assignments, ${text}`);
    setNotificationText(tabContainer, text);
    bindTooltipClickDismissal(tabContainer);
    refreshTooltip(tabContainer);
};

export const renderTabCount = (notificationCount) => {
    const elements = notificationElements();
    const { tab, badge } = elements;

    if (!tab || !badge) return;

    if (notificationCount <= 0) {
        hideTabCount(elements);
        return;
    }

    showTabCount(elements, notificationCount);
};
